import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setNotifications((prev) => [...prev, { id, message, type }]);

    // Auto-dismiss after 5 seconds if not a confirmation or prompt
    if (type !== 'confirm' && type !== 'prompt') {
      setTimeout(() => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
      }, 5000);
    }
  }, []);

  const addConfirm = useCallback((message, onConfirm, onCancel) => {
    const id = Date.now() + Math.random();
    setNotifications((prev) => [...prev, {
      id,
      message,
      type: 'confirm',
      onConfirm,
      onCancel
    }]);
  }, []);

  const addPrompt = useCallback((message, defaultValue, onSubmit, onCancel) => {
    const id = Date.now() + Math.random();
    setNotifications((prev) => [...prev, {
      id,
      message,
      type: 'prompt',
      defaultValue,
      onSubmit,
      onCancel
    }]);
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification, addConfirm, addPrompt, removeNotification, notifications }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export default NotificationContext;
